import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

/** Convert FastAPI/HTTPException detail into a display string. */
export function formatApiError(err) {
  if (!err) return "Something went wrong. Please try again.";
  const data = err?.response?.data;
  if (data && typeof data === "object") {
    if (typeof data.message === "string" && data.message.length) return data.message;
    const detail = data.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
      return detail
        .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
        .filter(Boolean)
        .join(" · ");
    }
    if (detail && typeof detail.msg === "string") return detail.msg;
  }
  if (typeof err?.message === "string") return err.message;
  return "Request failed. Please try again.";
}
